import N3dTools from "./n3dTools.js";

/**
 * 单体模型
 */
export default class N3dViewer extends N3dTools {
    constructor(container, initOptions) {
        super(container, initOptions);
    }

    init = url => {
        const params = v3d.AppUtils.getPageParams();
        console.log("params", params);
        const { app, PL } = this.createApp({
            container: this.container,
            sceneURL: url,
            // logicURL: assetsPrefix + 'model/visual_logic.js',
            callback: () => {
                // this.reset()
                this.brightnessContrast(0.03, 0.05);
                this.setScreenScale(window.devicePixelRatio)
            }
        });
        console.log("create", app, PL);
        this.app = app;
    };
}
